export const featureCardArtwork = {
  container: {
    height: "211px",
    left: "-31px",
    top: "-59px",
    width: "545px",
  },
  rings: [
    {
      height: "162px",
      left: "-18px",
      top: "-18px",
      width: "560px",
    },
    {
      height: "154px",
      left: "-2px",
      top: "-2px",
      width: "528px",
    },
    {
      height: "146px",
      left: "14px",
      top: "14px",
      width: "496px",
    },
    {
      height: "138px",
      left: "30px",
      top: "30px",
      width: "464px",
    },
  ],
};
